import { IHICustomer, IHICustomerDetails } from '../interfaces/IHealthInsurance'

import {
  RESET_HI_CUSTOMER,
  SET_HI_CUSTOMER,
  SET_HI_CUSTOMER_DETAILS,
} from './actionTypes'

export const setHICustomer = (customerData: IHICustomer) => ({
  type: SET_HI_CUSTOMER,
  payload: {
    customerData,
  },
})

export const setHICustomerDetails = (customerData: IHICustomerDetails) => ({
  type: SET_HI_CUSTOMER_DETAILS,
  payload: {
    customerData,
  },
})

export const resetHICustomer = () => ({
  type: RESET_HI_CUSTOMER,
})
